/* eslint-disable */
import React, { useState, useEffect } from 'react';
import ReactMapGL, { Marker } from 'react-map-gl';
import locationIcon from '../../assets/images/iconos/icono-016.png';
import mapboxgl from 'mapbox-gl';
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

const DespachoMap = ({ data }) => {
    
    const [viewport, setViewport] = useState({
        latitude: data.latitud,
        longitude: data.longitud,
        zoom: 8
    });

    const [ping, setPing] = useState(null);

    useEffect(() => {
        setPing({
            latitude: data.latitud,
            longitude: data.longitud,
        });
    },[])

    return (
      <div style={{ width: '100%', height: 300 }}>
        <ReactMapGL
                {...viewport}
                width="100%"
                height="100%"
                onViewportChange={(viewport) => setViewport(viewport)}
                mapboxApiAccessToken={'pk.eyJ1IjoiZGltb2l0IiwiYSI6ImNrNnhnZm4zcDBmdnAzZHJ2M3c0Y3ZhMmkifQ.XAj030Fj7M9w97BJil95hA'}
                mapStyle="mapbox://styles/mapbox/streets-v9"
                zoom={16}
                dragPan={false}
                
        >
            {ping &&
                <Marker {...ping} offsetLeft={-20} offsetTop={-10}>
                    <img src={locationIcon} style={{ width: 40, height: 40 }} alt="Punto de entrega"/>
                </Marker>
            }     
        </ReactMapGL>
      </div>
    )
}

export default DespachoMap;